<template>
  <div class="profile_detail">
    <!-- 헤더 -->
    <Head type='back' name='view_stamp' title='내가 찍은 스탬프' />
    <div class="course_box laststamp_wrap">
      <div class="select">
        <input v-model="year" type="text" readonly @click="openPopup(selectVals1, '연도선택')">
      </div>
      <p v-if="badgeStamp.length === 0" class="no_result">최근 획득 스탬프가 없습니다.</p>
      <ul>
        <li v-for="(data, idx) in badgeStamp" v-bind:key="idx">
          <div class="mystamp" @click="RecentStampPopup(data)">
            <img :src="data.badge_image_url" alt="mystamp">
          </div>
          <span>{{data.info_badge_name}}</span>
          <div class="star">
            <img :src="starIcon(data.user_mingle_star_cnt)" alt="" />
            {{(data.user_mingle_star_cnt === '0.0') ? '별점없음' : data.user_mingle_star_cnt}}
          </div>
        </li>
      </ul>
      <div class="more_view">
        <button v-if="!moreViewEnd" type="button" @click="moreView" :disabled="moreViewBtn">더보기</button>
      </div>
    </div>
    <PopupProfileStamp :stampInfo="stampInfo"/>
    <SelectPopup v-if="commonSelect.visible" @sendVal="changeSelect" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Head from '@/components/Head.vue'
import PopupProfileStamp from '@/components/popup/PopupProfileStamp.vue'
import SelectPopup from '@/components/SelectPopup.vue'
export default {
  name: 'LastStamp',
  components: {
    Head,
    PopupProfileStamp,
    SelectPopup
  },
  data () {
    return {
      stampInfo: null,
      year: '전체',
      selectVals1: ['전체'],
      params: {
        view_count: 12,
        last_key: '',
        year: ''
      },
      moreViewEnd: false
    }
  },
  methods: {
    RecentStampPopup (item) {
      this.$store.state.openProfileStamp = true
      this.stampInfo = item
    },
    starIcon (star) {
      const starScore = (star === '0.0') ? 'n' : 'p'
      return require(`@/assets/images/star_${starScore}.png`)
    },
    openPopup (list, title) {
      document.body.classList.add('overhidden')
      this.$store.state.commonSelect.value = this.year
      this.$store.state.commonSelect.visible = true
      this.$store.state.commonSelect.list = list
      this.$store.state.commonSelect.title = title
    },
    changeSelect (val) {
      this.year = val
      this.params.last_key = ''
      this.params.year = (val !== '전체') ? val.split('년')[0] : ''
      this.callApi()
    },
    moreView () {
      const lastArr = this.badgeStamp[this.badgeStamp.length - 1]
      this.params.last_key = `${lastArr.year}${lastArr.log_no}`
      this.callApi()
    },
    callApi () {
      this.moreViewEnd = false
      this.$store.dispatch('GetProfile', this.params)
    }
  },
  watch: {
    badgeStampInfo () {
      if (this.selectVals1.length === 1) {
        this.selectVals1 = this.selectVals1.concat(this.badgeStampInfo.year_list.map(v => `${v}년`))
      }
    },
    badgeStamp () {
      if (this.badgeStamp.length && (this.badgeStamp.length % this.params.view_count)) {
        this.moreViewEnd = true
      }
    }
  },
  mounted () {
    this.callApi()
  },
  computed: {
    ...mapState(['badgeStamp', 'openProfileStamp', 'commonSelect', 'badgeStampInfo', 'moreViewBtn'])
  }
}
</script>
<style>
  body {
    background-color: #f7f8f9;
  }
</style>
